import styled from 'styled-components'

export const TextAreaStyled = styled.textarea`
  padding: 10px;
  border-radius: 8px;
  max-width: 610px;
  min-width: 600px;
  max-height: 300px;
  border: 1px solid gray;
  font-size: 14px;
  font-weight: 500;
  ::placeholder {
    color: #b9b9b9;
  }
`

export const ContainerFpsComponent = styled.div`
  display: flex;
  justify-content: 'center';
  align-items: 'center';
  gap: 15px;
`

export const ContainerConfigPersonalized = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 640px;

  @media (max-height: 990px) {
    height: 600px;
  }

  @media (max-height: 915px) {
    height: 500px;
  }

  @media (max-height: 790px) {
    height: 400px;
  }
`

export const ContainerContentPersonalized = styled.div`
  padding: 30px;
  gap: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-height: 790px) {
    gap: 50px;
  }
`
